export const MAIL_PATTERN =
  '^[a-zA-Z0-9!#\\\\&$%\'*+=?^`{}|~_-](\\.?[a-zA-Z0-9\\\\!#$&%\'*+=?^`{}|~_-]){0,}' +
  '@[a-zA-Z0-9-]+\\.(?!-)([a-zA-Z0-9]?((-?[a-zA-Z0-9]+)+\\.(?!-))){0,}[a-zA-Z0-9]{2,8}$';
